'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Day status flags
var DAY_AVAILABLE = 0;
var DAY_DISABLED = 1;
var DAY_FULL = 2;
var DAY_CLOSED = 4;

// Forbidden day flags
var FRB_NONE = 0;
var FRB_BEGIN = 1;
var FRB_END = 2;
var FRB_BEGIN_END = FRB_BEGIN | FRB_END;

var WinresReservationCalendar = function () {
    function WinresReservationCalendar($scope, localizationService, $timeout) {
        _classCallCheck(this, WinresReservationCalendar);

        this.$scope = $scope;
        this.localizationService = localizationService;
        this.$timeout = $timeout;
    }

    _createClass(WinresReservationCalendar, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.daterangeOptions = this.getDateRangeOptions();

            this.$scope.$watch(function () {
                return _this.singleDatePicker;
            }, function () {
                return _this.daterangeOptions.singleDatePicker = _this.singleDatePicker;
            });

            // this.daterangeOptions = this.getDateRangeOptions('#reservation-tickets-calendar', 'reservation-tickets-calendar-button');
        }
    }, {
        key: 'getDateRangeOptions',
        value: function getDateRangeOptions() {
            var _this2 = this;

            var daterangeOptions = {
                'opens': 'right',
                'showCustomRangeLabel': false,
                'autoApply': true,
                'showDropdowns': false,
                'singleDatePicker': this.singleDatePicker,
                'parentEl': this.parentElement,
                'timePicker24Hour': true,
                'timePickerSeconds': true,
                'buttonClasses': this.buttonClasses,
                'isInvalidDate': function isInvalidDate(date) {
                    return _this2.isInvalidDate(date);
                },
                'isCustomDate': function isCustomDate(date) {
                    return _this2.isCustomDate(date);
                },
                'showISOWeekNumbers': this.showWeekNumber !== 'false',
                'locale': {
                    'format': 'DD.MM.YYYY', // DD.MM.YYYY YYYY-MM-DD dd/MM/yyyy
                    'separator': ' - ',
                    'weekLabel': '',
                    'daysOfWeek': this.daysOfWeekEn ? this.daysOfWeekEn.split(',') : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    'firstDay': 1
                }
            };

            if (this.localizationService.getLanguage() == 'fi') {
                daterangeOptions.locale.daysOfWeek = this.daysOfWeekFi ? this.daysOfWeekFi.split(',') : ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'];
                daterangeOptions.locale.monthNames = ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'];
            }

            if (this.localizationService.getLanguage() == 'sv') {
                daterangeOptions.locale.daysOfWeek = this.daysOfWeekSv ? this.daysOfWeekSv.split(',') : ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'];
                daterangeOptions.locale.monthNames = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
            }

            return daterangeOptions;
        }

        // Sets which dates cannot be clicked at all.
        //

    }, {
        key: 'isInvalidDate',
        value: function isInvalidDate(date) {
            if (this.disabled) {
                // Disable all dates.
                return true;
            }

            var formattedDate = date.format('YYYY-MM-DD'); // YYYY-MM-DD
            var index = _.findIndex(this.daterangeDates, function (day) {
                return day.Date === formattedDate;
            });

            if (index !== -1) {
                var day = this.daterangeDates[index];
                var prevDay = this.daterangeDates[index - 1];

                if (this.singleDatePicker) {
                    if (day.Status === DAY_AVAILABLE) {
                        return false;
                    }
                } else {
                    var canBegin = day.Status === DAY_AVAILABLE && !(day.Forbidden & FRB_BEGIN);
                    var canEnd = prevDay && prevDay.Status === DAY_AVAILABLE && !(day.Forbidden & FRB_END);
                    if (canBegin || canEnd) {
                        return false;
                    }
                }
            }

            // Red |_|
            return true;
        }

        // Adds css classes to dates based on condition
        // http://www.daterangepicker.com/#options

    }, {
        key: 'isCustomDate',
        value: function isCustomDate(date) {
            var formattedDate = date.format('YYYY-MM-DD'); // YYYY-MM-DD
            var index = _.findIndex(this.daterangeDates, function (day) {
                return day.Date === formattedDate;
            });

            // console.log(this.ngModel);

            if (index == -1) {
                // The day is out of range of the calendar, so presumably in the past.
                // We don't know anything about it, and we probably want to show it in gray.
                // return ['am-past', 'pm-past'];
                return ['am-disabled', 'pm-disabled'];
            }

            var day = this.daterangeDates[index];
            var prevDay = this.daterangeDates[index - 1];

            var checkForb = !this.singleDatePicker;
            var forbEnd = checkForb && day.Forbidden & FRB_END;
            var forbBegin = checkForb && day.Forbidden & FRB_BEGIN;

            var tags = [];

            var possibleTags = {
                // AM - First part of the day. Reservations with departure on that day or continuing through that day.

                // Selecting this day as the end date is not allowed for whatever reason.
                // This could be broken out into more detail if that is desired, but for now,
                // these are all grey.
                'am-disabled':
                // Day is the first that we have information about. Previous day is not known.
                !prevDay ||
                // Previous day is closed, so overnight reservations ending on this day are not possible.
                prevDay && prevDay.Status & DAY_CLOSED ||
                // Previous day is disabled, so overnight reservations ending on this day are not possible.
                prevDay && prevDay.Status & DAY_DISABLED,

                'am-forbidden': forbEnd,

                // Previous day is full, so overnight reservations ending on this day are not possible.
                'am-full': prevDay && prevDay.Status & DAY_FULL,

                // Previous day is available.
                'am-available': prevDay && prevDay.Status === DAY_AVAILABLE && !forbEnd,

                // PM - Second part of the day. Reservations with arrival on that day or continuing through that day.

                // Selecting this day as the begin date is not allowed for whatever reason.
                // This could be broken out into more detail if that is desired, but for now,
                // these are all grey.

                'pm-disabled':
                // Day is closed, so reservations for this day are not possible.
                day.Status & DAY_CLOSED ||
                // Day is disabled, so reservations for this day are not possible.
                day.Status & DAY_DISABLED,

                'pm-forbidden': forbBegin,

                // Day is full, so reservations for this day are not possible.
                'pm-full': day.Status & DAY_FULL,

                // Day is available.
                'pm-available': day.Status === DAY_AVAILABLE && !forbBegin
            };

            if (this.singleDatePicker) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.keys(possibleTags)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var tag = _step.value;

                        if (tag.startsWith('am-')) {
                            possibleTags[tag] = possibleTags['pm-' + tag.substring(3)];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(possibleTags)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _tag = _step2.value;

                    var condition = possibleTags[_tag];
                    if (condition) {
                        tags.push(_tag);
                    }
                }

                // console.log(new Date(), day.Date, day.Status, day.Forbidden, tags);
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return tags;
        }
    }]);

    return WinresReservationCalendar;
}();

WinresReservationCalendar.$inject = ['$scope', 'localizationService', '$timeout'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresReservationCalendar';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresReservationCalendar', require('./winresReservationCalendar.html'));
}]);

_module3.default.component('winresReservationCalendar', {
    templateUrl: getTemplate,
    controller: WinresReservationCalendar,
    bindings: {
        ngModel: '=',
        daterangeDates: '<',
        singleDatePicker: '<',
        calendarId: '@',
        parentElement: '@',
        buttonClasses: '@',
        disabled: '<',
        showWeekNumber: '@',
        daysOfWeekEn: '@',
        daysOfWeekFi: '@',
        daysOfWeekSv: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationCalendar/winresReservationCalendar.js
// module id = 384
// module chunks = 2